import React, { Dispatch, SetStateAction } from 'react';
import * as Select from '@radix-ui/react-select';
import classnames from 'classnames';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { BiSolidDownArrow, BiSolidUpArrow } from 'react-icons/bi';
import styles from "./Select.module.css";

// 1. Defina os tipos para as props
interface SelectWithLabelProps {
  selectedValues: { value: string, label: string}[];
  selectedValue: string;
  setSelectedValue: Dispatch<SetStateAction<any>>;
}

const SelectWithLabel: React.FC<SelectWithLabelProps> = ({ selectedValue, setSelectedValue, selectedValues }) => {
  return (
    <Select.Root onValueChange={value => setSelectedValue(value)}>
      <Select.Trigger className={styles.SelectTrigger} aria-label="Food">
        <Select.Value defaultValue={selectedValue} placeholder="Escolha" />
        <Select.Icon className={styles.SelectIcon}>
          <BiSolidDownArrow />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content className={styles.SelectContent}>
          <Select.ScrollUpButton className={styles.SelectScrollButton}>
            <BiSolidUpArrow />
          </Select.ScrollUpButton>
          <Select.Viewport className={styles.SelectViewport}>
            <Select.Group>
              <Select.Label className={styles.SelectLabel}>Escolha</Select.Label>
              <Select.Separator className={styles.SelectSeparator} />
              {
                selectedValues.map(({ label, value }, index) => {
                  return <SelectItem key={index} value={value}>{label}</SelectItem>
                })
              }
            </Select.Group>
          </Select.Viewport>
          <Select.ScrollDownButton className={styles.SelectScrollButton}>
            <BiSolidDownArrow />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

// 3. Ajuste o componente SelectItem para aceitar os tipos corretos
interface SelectItemProps {
  children: React.ReactNode;
  className?: string;
  value: string;
}

const SelectItem = React.forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <Select.Item className={classnames(styles.SelectItem, className)} {...props} ref={forwardedRef}>
        <Select.ItemText>{children}</Select.ItemText>
        <Select.ItemIndicator className={styles.SelectItemIndicator}>
          <AiOutlineCheckCircle size={22} />
        </Select.ItemIndicator>
      </Select.Item>
    );
  }
);

export default SelectWithLabel;
